<template>
  <section class="userSteps">
      <Header />
    <div class="ContentBlock">
      <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg"> 
        <!-- <button type="button" class="close_btn">
          <vue-feather size="26" type="x"></vue-feather>
        </button> -->
      </div>
      <div class="messageBlock" v-if="store.error.msg">
        <p class="alert" :class="(store.error.type == 'error') ? 'alert-danger' : 'alert-success'">{{store.error.msg}}</p>
      </div>
      <form class="inputForm">
        <h3 class="text-center mb-md-5 mb-4">{{$t('view_register.text1')}}</h3>
        <!-- <a href="javascript:void(0)" class="border_btn d-flex align-items-center mb-2"  @click="login()"><img
            src="assets/images/google-login.svg" loading="lazy" width="24" height="24" alt="google"
            title="Google Login" /> <span>Continue with Google</span></a> -->
            <!-- <a href="javascript:void(0)" class="border_btn d-flex align-items-center mb-2"><img
            src="assets/images/google-login.svg" loading="lazy" width="24" height="24" alt="google"
            title="Google Login" /> <span> </span></a>-->
            <div class="d-flex justify-content-center googleSignInButton">
              <GoogleSignInButton
                @success="handleLoginSuccess"
                @error="handleLoginError"
                size = "medium"
            ></GoogleSignInButton>
            </div>
            <!-- <div class="d-flex justify-content-center googleSignInButton">
                <vue-apple-login></vue-apple-login>
            </div> -->
            <!-- <GoogleSignInButton
            @success="handleLoginSuccess"
            @error="handleLoginError"
          ></GoogleSignInButton> -->
        <!-- <a href="javascript:void(0)" class="border_btn d-flex align-items-center mb-2"><img
            src="assets/images/mac-login.svg" loading="lazy" width="24" height="24" alt="Apple"
            title="Continue with Apple" /> <span>Continue with Apple</span></a> -->
       <!--  <a href="javascript:void(0)" class="border_btn d-flex align-items-center mb-2"><img
            src="assets/images/finvasia-login.svg" loading="lazy" width="24" height="24" alt="Finvasia"
            title="Continue with Finvasia ID" /> <span>Continue with Finvasia ID</span></a> -->
        <p class="or medium text-center">{{$t('view_register.text2')}}</p>
         <Form @submit="register">
          <div class="d-flex align-items-start flex-wrap">
            <float-label class="form-group w-md-50 pe-md-2">
              <Field
                class="form-control"
                name="first name"
                :placeholder="$t('personal_details.text5')"
                v-model="form.fname"
                rules="required|onlyLetters"
                autocomplete="off"
              />
              <ErrorMessage class="text-danger" name="first name" />
          </float-label>
          <float-label class="form-group w-md-50 ps-md-2">
            <Field
              class="form-control"
              name="last name"
              :placeholder="$t('personal_details.text6')"
              v-model="form.lname"
              rules="required|onlyLetters"
              autocomplete="off"
            />
            <ErrorMessage class="text-danger" name="last name" />
            </float-label>
          </div>
            <div class="countrySelect form-group position-relative filter-dropdown" @click="autoFocus()" :class="[{'selected' : country.name}]">
              <a @click="selectButton = !selectButton" href="javascript:void(0)"
                  class="selectButton d-flex align-items-center justify-content-between"><span
                      class="d-flex align-items-center" v-if="country.id && country.name"><img class="me-2" :src="`${static_vars.imagePath}/assets/images/country_flag/${country.name.toLowerCase()}.webp`"
                          :alt="$t('personal_details.text21')" :title="$t('personal_details.text21')" loading="lazy" width="20" height="20"/>{{country.name}}</span>
                          <span v-else>&nbsp;</span>
                  <vue-feather size="20" type="chevron-down"></vue-feather>
              </a>
              <label class="afterSelect">{{$t('personal_details.text7')}}</label>
              <ul class="dropdown_menu_animated scrollable" :class="selectButton ? 'show' : ''" > 
                  <li class="form-group mb-1">
                      <input type="text" :placeholder="$t('personal_details.text8')" class="form-control radius-0" v-model="countrysearch" id="searchInput"/>
                  </li>
                  <li v-for="item,key in getCountries" :key="key">
                      <a href="javascript:void(0)" class="d-flex align-items-center" @click="country = item;selectButton = false;countrysearch = '';changecountry(item)" ><img class="me-2"
                              :src="`${static_vars.imagePath}/assets/images/country_flag/${item.name.toLowerCase()}.webp`" :alt="$t('personal_details.text21')" :title="item.name" loading="lazy" width="20" height="20"/>
                          {{item.name}}</a>
                  </li>
              </ul>
            </div>
            <span v-if="isCountry" role="alert" class="text-danger">{{$t('changes.text6')}}</span>
            <div class="form-group mb-4 position-relative" :class="selectNumber ? 'selected' : ''">
              <!-- :rules="'required|digits:'+selected_country_phone_limit"  -->
              <Field
                  v-slot="{ field }"
                  name="Phone Number"
                  :rules="'required|min:7|max:15'" 
                  v-model="form.mobile" >
                  <vue-tel-input
                  v-bind="field"
                  :auto-format = "false"
                  v-model="form.mobile"
                  @country-changed="GetCode"
                  @blur="onMobileInput"
                  @keyup="onMobileInput"
                  :inputOptions="options"
                  :onlyCountries ="getAllowCountry()"
                  :custom-validate="form.mobile!=''? new RegExp(/^[0-9]+$/):false"
                  ref="phone"
                  inputmode="numeric"
                  ></vue-tel-input>
            </Field>
            <ErrorMessage class="text-danger" name="Phone Number" />
            <!-- <span v-if="isPhone" role="alert" class="text-danger">{{$t('changes.text8')}}</span> -->
          </div>
            <float-label class="form-group">
              <!-- <input type="text" class="form-control" placeholder="Username or email" /> -->
               <Field
                type="email"
                class="form-control"
                name="Email Address"
                autofill="off"
                autocomplete="username"
                v-model="form.username"
                :placeholder="$t('view_login.text6')"
                rules="required|email|max:255"
              />
              <ErrorMessage class="text-danger" name="Email Address" />
            </float-label>
            <float-label class="form-group mb-1">
              <div class="position-relative iconInput">
                <!-- <input type="password" class="form-control" placeholder="Enter Password" /> -->
                <Field
                  :type="inputtype"
                  class="form-control"
                  autofill="off"
                  name="Password"
                  v-model="form.password"
                  rules="required|min:8"
                  :placeholder="$t('view_login.text7')"
                />
                <ErrorMessage class="text-danger" name="Password" />
                <vue-feather class="position-absolute eye pointer"  :type="iconType" size="23" @click="switchVisibility"></vue-feather>
              </div>
              <div class="toolMob d-flex align-items-center justify-content-end" :class="(!validPassword && form.password) ? 'orange' : (validPassword && form.password) ? 'green' : ''">
                    <p class="f-10 mb-0">{{$t('view_register.text3')}}</p>
                    <div class="tooltipbutton w-auto">
                        <span class="tooltiptext">
                            <div class="strenghtPassword m-0">
                                <ul class="passwordStrenth mb-0">
                                    <li :class="(upperCaseOk) ? 'green' : 'red'">{{$t('view_register.text4')}}</li>
                                    <li :class="(form.password.length >= 8) ? 'green' : 'red'">{{$t('view_register.text5')}}</li>
                                    <li :class="(numberOk) ? 'green' : 'red'">{{$t('view_register.text6')}}</li>
                                    <li :class="(letterOk) ? 'green' : 'red'">{{$t('view_register.text7')}}</li>
                                    <li :class="(SpecialCharOk) ? 'green' : 'red'">{{$t('view_register.text8')}}</li>
                                </ul>
                            </div>
                        </span>
                        <vue-feather class="mx-1 alertType" :type="(!validPassword && form.password) ? 'alert-circle' : (validPassword && form.password) ? 'check-circle' : 'alert-circle'" size="18"></vue-feather>
                    </div>
                    <span class="barPass"></span>
              </div>
            </float-label>
            <label class="customCheckBox line-4 mb-4">
                {{$t('get_otp.text5')}}<a target="_blank" class="semibold underline" :href="`${static_vars.domainURL}terms-of-service`">{{$t('get_otp.text6')}}</a>,
                <a target="_blank" class="semibold underline" :href="`${static_vars.domainURL}privacy-policy`">{{$t('get_otp.text7')}}</a>,
                <a class="semibold underline" :href="`${static_vars.domainURL}conflict-of-interest-policy`" target="_blank">{{$t('get_otp.text8')}}</a>,
                <a target="_blank" class="semibold underline" :href="`${static_vars.domainURL}declaration-of-consent`">{{$t('get_otp.text9')}}</a>{{$t('get_otp.text10')}}
                <a target="_blank" class="semibold underline" :href="`${static_vars.domainURL}risk-disclaimer`">{{$t('get_otp.text11')}}</a>
                <input type="checkbox" v-model="form.terms" />
                <Field type="hidden" name="Terms" rules="required" v-if="!form.terms" />
                <span class="checkmark"></span>
            </label>
            <ErrorMessage name="Terms" class="text-danger" />
            <div class="buttonElement my-3">
              <a class="grd_btn full_size disabled" v-if="!validPassword || !captchaToken">{{$t('view_register.text9')}}</a>
              <button type="submit" class="grd_btn full_size" v-else>{{$t('view_register.text9')}}</button>
            </div>
        </Form>
        <div class="otherLogin text-center">
          <p>{{$t('view_register.text10')}}<a :href="`${static_vars.domainURL}login`" class="underline">{{$t('view_register.text11')}}</a> </p>
        </div>
      </form>
    </div>
    <stepFooter />
  </section>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";
import FloatLabel from 'vue-float-label/components/FloatLabel'
import stepFooter from "../../components/shared/step_footer";
//import { useTokenClient } from "vue3-google-signin"
// import { VueReCaptcha } from 'vue-recaptcha-v3'
import { load } from 'recaptcha-v3'
import $ from 'jquery';
import jsonData from '../../../public/countries.json';


export default {
    setup() {
    const store = useMainStore();
    const Crypto = require("crypto-js")
    // const handleOnSuccess = (response) => {
    //     console.log("Access Token: ", response);
    // };

    // const handleOnError = (errorResponse) => {
    //     console.log("Error: ", errorResponse);
    // };

    // const {  login } = useTokenClient({
    //     onSuccess: handleOnSuccess,
    //     onError: handleOnError,
    // });
    return { store,Crypto }; //,login,Crypto
  },
  data() {
    return {
        form : {
            username : '',
            password : '',
            fname : '',
            lname : '',
            mobile : '',
            phonecode : '',
            terms:false
        },
        selectNumber : false,
        country : {},
        captchaToken  : '',
        showpassword: false,
        iconType: "eye-off",
        inputtype: "password",
        upperCaseOk : false,
        numberOk : false,
        SpecialCharOk : false,
        letterOk : '',
        validPassword : false,
        options: { placeholder: "Enter your phone number" },
        isCountry : false,
        // isPhone : false,
        selectButton: false,
        countrysearch : '',
        selected_phone_country:null,
        default_mobile_length:10,
        countries_json:jsonData
    }
  },
    watch: {
        "form.password": function (val) {
            let upperCase = new RegExp("[A-Z]"),
            numbers = new RegExp("[0-9]"),
            letter = new RegExp("[A-Za-z]"),
            specialcharacter = new RegExp("[!,%,&,@,#,$,^,*,?,_,~,/]");
            if (val.match(upperCase)) {
                this.upperCaseOk = true
            }else{
                this.upperCaseOk = false
            }
            if(val.match(numbers)){
                this.numberOk = true
            }else{
                this.numberOk = false
            }
            if (val.match(letter)) {
                this.letterOk = true;
            } else {
                this.letterOk = false;
            }
            if (val.match(specialcharacter)) {
                this.SpecialCharOk = true;
            } else {
                this.SpecialCharOk = false;
            }
            if(this.upperCaseOk && this.numberOk && this.SpecialCharOk && val.length >= 8 && this.letterOk){
                this.validPassword = true
            }else{
                this.validPassword = false
            }

        },
        // "form.mobile"(){
        //   if(this.form.mobile && this.form.mobile.length >= 7){
        //     this.isPhone = false
        //   }
        // },
        "store.flavorData"(){
          if(Object.keys(this.store.countryList).length && this.store.flavorData?.userCountry?.id){
            if(Object.keys(this.store.countryList).includes(this.store.flavorData?.userCountry?.id.toString())){
              this.country = this.store.countryList[this.store.flavorData?.userCountry?.id]
              this.changecountry(this.country)
            }else{
              this.country = Object.values(this.store.countryList)[0]
              this.changecountry(this.country)
            }
          }
        }
    },
  components: {
    stepFooter,
    FloatLabel,
    Form,
    Field,
    ErrorMessage,
  },
  computed:  {
    getCountries(){
        if(Object.keys(this.store.countryList).length > 0){
            let data = Object.values(this.store.countryList);
            if(this.countrysearch){
                return data.filter(item => item.name.toLowerCase().includes(this.countrysearch.toLowerCase()))
            }else{
                return data
            }

        }else{
            return []
        }
    },

    selected_country_phone_limit(){
        let selected_con = this.countries_json.find(arr=> arr.isoCode == this.selected_phone_country?.iso2);
        return selected_con ? selected_con.digits:this.default_mobile_length;
    }

    // formattedMobile: {
    //   get() {
    //     return this.form.mobile;
    //   },
    //   set(value) {
    //     // Filter out non-numeric and non-space characters
    //     const filteredValue = value.replace(/[^1-9\d]/g, '');
    //     this.form.mobile = filteredValue;
    //     return filteredValue;
    //   }
    // }
  },
  methods:{
    getCountryData(code){
        if(Object.keys(this.store.countryList).length && code){
            return Object.values(this.store.countryList).filter(val => val.isoCodeA3 == code)[0]

        }
      },
      onMobileInput(){
        if(parseInt(this.form.mobile) == 0){
            this.form.mobile = '';
        }
      },
    GetCode(e) {
      this.selected_phone_country = e;
      this.form.phonecode = e.dialCode;
    },
    changecountry(item) {
        this.$refs.phone.choose(item.isoCode);
      },
      getAllowCountry(){
          return Object.values(this.store.countryList).map((val) => val.isoCode) || [];
      },
    register(type,response){
         load(`${this.static_vars.recaptchaKey}`,{useRecaptchaNet: true}).then((recaptcha) => {
            recaptcha.execute('login').then((token) => {
                // console.log('again',token) // Will print the token
                this.captchaToken = token
                if(this.captchaToken){
                  let formData  = {};
                      if(this.validPassword){
                          if (this.validEmail()) {
                              formData['email'] = this.form.username
                              formData['password'] = this.form.password
                              formData['tokenType'] = 'EMAIL'
                          }else{
                              formData['username'] = this.form.username
                              formData['password'] = this.form.password
                              formData['tokenType'] = 'USERNAME'
                          }
                          if(this.captchaToken){
                              formData['captcha'] = {};
                              formData['captcha']['response'] = this.captchaToken
                          }
                          if(Object.keys(this.country).length){
                              this.isCountry = false
                          }else{
                              this.isCountry = true
                          }
                          // if(this.form.mobile){
                          //   this.isPhone = false
                          // }else{
                          //   this.isPhone = true
                          // }
                          if(this.form.fname){
                            formData['firstname'] = this.form.fname
                          }
                          if(this.form.lname){
                            formData['lastname'] = this.form.lname
                          }
                          if(this.country?.id){
                            formData['countryId'] = this.country.id
                          }
                          if(this.form.mobile){
                            formData['phoneNumber'] = this.form.mobile
                          }
                          if(this.form.phonecode){
                            formData['phoneCountryCode'] = this.form.phonecode
                          }
                          // if(!this.isCountry && !this.isPhone){
                          if(!this.isCountry){
                            this.store.register(formData, true,this,'');
                          }
                      }else{
                          if(type){
                              formData['tokenType'] = 'GOOGLE'
                              formData['grant_type'] = 'password';
                              formData['token'] = response;
                              if(this.captchaToken){
                                  formData['captcha'] = {};
                                  formData['captcha']['response'] = this.captchaToken
                              }
                              this.store.register(formData, true,this,type);
                          }
                      }
                }
              })
              // .then(function(){
              //   this.store.callCustomerDetail();
              // })
             
              
          })
    },
   
    CretioFunc(){
        try{
            // window.gtag('event', 'test_verify');
          if(Object.keys(this.store.flavorData).length && this.store.flavorData.userCountry && Object.keys(this.store.flavorData.userCountry).length && this.store.flavorData.userCountry.isoCode){
                for(var key in this.static_vars.cretioCountryJson){
                    if(key == this.store.flavorData.userCountry.isoCode){
                        var s = document.createElement("script");
                        s.type = "text/javascript";
                        s.async = true;
                        s.src = `//dynamic.criteo.com/js/ld/ld.js?a=${this.static_vars.cretioCountryJson[key]}`;
                        $("head").append(s);
                        window.criteo_q = window.criteo_q || [];
                         var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                        window .criteo_q.push(
                         { event: "setaccount", account: this.static_vars.cretioCountryJson[key]}, // You should never update this line
                         { event: "setSiteType", type: deviceType},
                         { event: "setemail", email: this.Crypto.SHA256('1').toString() , hash_method: "sha256" },
                        { event: "viewBasket", user_segment : 1, item: [
                           {id : (Math.random()*10000).toString(), price:1, quality : 1}
                        ]}
                        );
                    }
                }
            }
        }catch(e){
          console.log('cretio ex',e)
        }
    },
    CretioGoogleFunc(){
        try{
             window.gtag('event', 'Gen_Lead_2.0');
            window.gtag('event', 'test_verify');
            window.fbq('trackCustom', 'email_verify', { 'email' : this.store.userAccoutDetail?.email,'value' : '20','country' : this.store.flavorData?.userCountry?.name },{'eventID': `${this.store.userAccoutDetail?.id}_email_verify`});
            if(Object.keys(this.store.flavorData).length && this.store.flavorData.userCountry && Object.keys(this.store.flavorData.userCountry).length && this.store.flavorData.userCountry.isoCode){
                for(var key in this.static_vars.cretioCountryJson){
                    if(key == this.store.flavorData.userCountry.isoCode){
                        var s = document.createElement("script");
                        s.type = "text/javascript";
                        s.async = true;
                        s.src = `//dynamic.criteo.com/js/ld/ld.js?a=${this.static_vars.cretioCountryJson[key]}`;
                        $("head").append(s);
                        window.criteo_q = window.criteo_q || [];
                        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                        window .criteo_q.push(
                         { event: "setaccount", account: this.static_vars.cretioCountryJson[key]}, // You should never update this line
                          { event: "setSiteType", type: deviceType},
                         { event: "setemail", email: this.Crypto.SHA256('1').toString() , hash_method: "sha256" }, 
                          //{ event: "setEmail", email: "1"  },
                            // { event: "viewBasket", user_segment : 1, item: [
                            //      {id : (Math.random()*10000).toString(), price:1, quality : 1}
                            // ]},
                            { event: "trackTransaction", id: (Math.random() * 50000), item: [
                                {id :  (Math.random()*10000).toString(), price:1, quality : 1}
                            ]}
                        );
                    }
                }
            }
        }catch(e){
          console.log('cretio ex',e)
        }
    },
    handleLoginSuccess(response){
        if(response.credential){
            this.register('Google',response.credential);
        }
    },
    handleLoginError(){
        console.error("Login failed");
    },
    loginMannual(data){
        let formData = {};
        formData['grant_type'] = 'password'
        formData['username'] = this.form.username
        formData['password'] = this.form.password
        formData['tokenType'] = data
        this.store.login(formData,false,'basic',this)
    },
    loginWithGoogle(data){
        let formData = {};
        formData['grant_type'] = 'password'
        formData['googleToken'] = data
        this.store.login(formData,false,'basic',this)
        
    },

    callCustomerDetail(){
        this.store.callCustomerDetail({},true, this)
    },
    validEmail(){
        let regexp =  /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return regexp.test(this.form.username.toLowerCase())
    },
    switchVisibility() {
      this.showpassword = !this.showpassword;
      if (this.showpassword) {
        this.inputtype = "text";
        this.iconType = "eye";
      } else {
        this.inputtype = "password";
        this.iconType = "eye-off";
      }
    },
    autoFocus(){ // Autofocus search field
      this.countrysearch = '';
      let input = document.getElementById('searchInput');
      input.focus();
    }
  
  },
  mounted(){
    load(`${this.static_vars.recaptchaKey}`,{useRecaptchaNet: true}).then((recaptcha) => {
      recaptcha.execute('login').then((token) => {
          // console.log('token',token) // Will print the token
          this.captchaToken = token
        })
    })
    const _that = this;
    $(document).on("click", function (event) {
        if (!$(event.target).closest(".filter-dropdown").length) {
            _that.selectButton = false;
        }
    });
  },
  created(){
    this.store.callCountryList({},true).then((response) =>{
      if(Object.keys(response).length && this.store.flavorData?.userCountry?.id){
        if(Object.keys(response).includes(this.store.flavorData?.userCountry?.id.toString())){
          this.country = response[this.store.flavorData?.userCountry?.id]
          this.changecountry(this.country)
        }else{
          this.country = Object.values(response)[0]
          this.changecountry(this.country)
        }
      }
    })
    this.CretioFunc()
  }
}
</script>
<style>
    .disabled {
    pointer-events: none;
    opacity: 0.5;
    }
</style>